// extracted by mini-css-extract-plugin
module.exports = {"rootTouchBuffer":"Handle_rootTouchBuffer__3dqGc","visibleHandle":"Handle_visibleHandle__1-4VK","dragged":"Handle_dragged__2hgJQ"};